export class Demographics {
  id?: string;
  phone?: string;
  email?: string;
  address?: string;
  country?: string;
  [key: string]: any;
}
